import {Space} from "antd";
import {useCreateProductContext} from "../../context/create-product";
import {CreateProductBasicFormStep} from "../basic-form";
import {CreateProductCheckoutFormStep} from "../checkout-form";
import {FormWrapper} from "../../../../../components/form-wrapper";
import {CreateProductContentUploadStep} from "../content-upload";
import {CreateProductCoverImagesUploadStep} from "../cover-images-upload";
import {CreateProductFormStepsMobile} from "../create-product-steps";
import {StyledHideStepOnDesktop} from "../../../../../components/offering-form/general/steps/styles";
import {ProductVariantForm} from "../variant-form";
import {CreateProductAutomationsStep} from "../automations";
import {DraftResumeBanner} from "../../../../../components/offering-form/general/draft-resume-banner";
import {useDraftResumeBanner} from "../../../../../utils/offering-create-draft";

export function CreateProductMultiStepForm() {
  const {
    dispatch,
    wasDraftRestored,
    state: {currentCreateProductStep},
  } = useCreateProductContext();
  const {formKey, showBanner, handleStartFresh} = useDraftResumeBanner(
    wasDraftRestored,
    dispatch
  );

  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      {showBanner ? <DraftResumeBanner onStartFresh={handleStartFresh} /> : null}
      <StyledHideStepOnDesktop>
        <CreateProductFormStepsMobile />
      </StyledHideStepOnDesktop>
      <FormWrapper key={formKey}>
        {currentCreateProductStep === "basicForm" ? (
          <CreateProductBasicFormStep />
        ) : currentCreateProductStep === "checkoutForm" ? (
          <CreateProductCheckoutFormStep />
        ) : currentCreateProductStep === "coverImagesUpload" ? (
          <CreateProductCoverImagesUploadStep />
        ) : currentCreateProductStep === "variantForm" ? (
          <ProductVariantForm />
        ) : currentCreateProductStep === "contentUpload" ? (
          <CreateProductContentUploadStep />
        ) : currentCreateProductStep === "automations" ? (
          <CreateProductAutomationsStep />
        ) : null}
      </FormWrapper>
    </Space>
  );
}
